export const pageViewMixin = {
  created() {
  },
  mounted() {
    this.$store.commit("PageView/init");
    this.pageViewAttemptPageView();
  },
  methods: {
    // Wrapper for matomo's trackPageView, also setting additional custom dimension for the node id's if they're to be added.
    // EXPECTS 'this' in context i.e. needs to be run through bind ( pageViewOurTrackPageView.bind(this)(); )
    pageViewOurTrackPageView() {
      if (this.$matomo) {
        const pageViewNids = this.$store.getters["PageView/getData"](this);

        if (pageViewNids && pageViewNids.length > 0) {
          this.$matomo.setCustomDimension(
            this.$config.matomoPageViewDataDimension,
            pageViewNids.join(",")
          );
        }

        // Based on how this value is set in vue-matomo
        const url = this.$router.resolve(this.$route.fullPath).href;
        if (url) {
          this.$matomo.setCustomUrl(window.location.origin + url);
        }

        this.$store.commit("PageView/dequeue");
        this.$matomo.trackPageView(this.$route.fullPath);

        // Check if the current route is not the login page
        if (this.$route.path !== "/login") {
          // NOTE: this.$metaInfo.title seems to generally have the right title,
          // but let's fall back to the often incorrect document.title


          // Track the custom event for page view using the specified format
          this.$matomo.trackEvent("General", "LoggedInPageView", this.$metaInfo?.title ?? document.title);
          if(this.$store.$churnZero) {
            this.$store.$churnZero.trackEvent("LoggedInPageView", this.$metaInfo?.title ?? document.title);
          }
        }

        if (pageViewNids) {
          this.$matomo.deleteCustomDimension(
            this.$config.matomoPageViewDataDimension
          );
        }
      }
    },

    // Starts attempting the page view, if (pageViewWillSetNids) equates to true it will wait for nodes to be added before tracking the page view, otherwise tracks it once matomo is ready.
    // EXPECTS 'this' in context i.e. needs to be run through bind ( pageViewAttemptPageView.bind(this)(); )
    pageViewAttemptPageView() {
      this.pageViewWaitForPredicate(
        0,
        () => {
          return this.$matomo;
        },
        () => {
          if (this.$store.getters["PageView/getWillSetData"](this)) {
            this.pageViewWaitForPredicate(
              0,
              () => {
                return this.$store.getters["PageView/isReady"](this);
              },
              () => {
                this.pageViewOurTrackPageView();
              }
            );
          } else {
            this.pageViewOurTrackPageView();
          }
        }
      );
    },

    // Assists in waiting for up to 100 x 50 ms running the callback once the predicate returns true or after 100 attempts.
    pageViewWaitForPredicate(counter, predicate, callback) {
      if (counter > 100) {
        // Call it anyway, assume we'll never get what we're waiting for.
        callback();
        return;
      }

      if (predicate()) {
        callback();
      } else {
        // Not very elegant solution but we need to wait for things being loaded...
        setTimeout(() => {
          this.pageViewWaitForPredicate(counter + 1, predicate, callback);
        }, 50);
      }
    },
  },
};
